// apps/spa/src/hooks/useReminderHistory.ts
// TanStack Query wrapper for GET /api/reminders/:id/history.
//
// Only enabled when reminderId is provided (non-null, non-empty).
// Fetches the last 10 audit_log entries for the reminder matching
// action IN ('reminder.post_now', 'reminder.dispatch').
//
// staleTime 30_000 (30s) — history is reasonably fresh but not live.
// The panel re-fetches when the user collapses and re-expands a row.

import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export type AuditLogRow = {
  id: string;
  guildId: string;
  actorId: string;
  action: string;
  targetType: string | null;
  targetId: string | null;
  payloadJson: string | null;
  ts: number;
};

export type ReminderHistoryResult = {
  entries: AuditLogRow[];
};

export function useReminderHistory(reminderId: string | null) {
  return useQuery({
    queryKey: ['reminder-history', reminderId] as const,
    queryFn: () => api<ReminderHistoryResult>(`/api/reminders/${reminderId}/history`),
    enabled: !!reminderId,
    staleTime: 30_000,
  });
}
